import { isArray, isObject, isString } from 'lodash'
import BMF from 'browser-md5-file';
import { toast } from './utils';
// 下载excel
export function downLoadExcel (data, name) {
  if (!name) name = new Date().valueOf()
  const blob = new Blob([data])// 处理文档流
  const fileName = `${name}.xlsx`
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
  return true
}
export function isJSONStr(str) {
  if (isString(str)) {
    try {
      let obj = JSON.parse(str)
      if((isObject(obj) || isArray(obj)) && obj){
        return obj
      } else {
        return false
      }
    } catch(e) {
      return false
    }
  }
  return false
}

export function getFileMd5(file) {
  const bmf = new BMF()
  return new Promise((resolve, reject) => {
    bmf.md5(file, function(err, md5) {
      if (err) reject(false)
      else resolve(md5)
    })
  })
}

// 大文件分片
export async function sliceFile(file, perPieceSize = 5) {
  if (!file) return false
  const fileSize = file.size
  const bytesPerPiece = perPieceSize * 1024 * 1024
  const totalPieces = Math.ceil(fileSize / bytesPerPiece)
  let fileMd5 = await getFileMd5(file)
  if (!fileMd5) {
    toast({msg: '获取原文件的MD5值失败', type: 'error', title: '错误提示'})
    return false
  }
  let start = 0
  let end = 0
  let index = 1
  let chunkArr = []
  while(start < fileSize) {
    end = start + bytesPerPiece;
    if(end > fileSize) {
      end = fileSize
    }

    let chunk = file.slice(start,end)
    let chunkMd5 = await getFileMd5(chunk)
    if (!chunkMd5) {
      toast({msg: '获取切片文件的MD5值失败', type: 'error', title: '错误提示'})
      return false
    }
    let chunkObj = {
      file: chunk,
      md5: chunkMd5,
      index: index
    }
    chunkArr.push(chunkObj)
    start = end
    ++index
  }
  return {
    originFileMd5: fileMd5,
    sliceNum: totalPieces,
    chunkArr: chunkArr
  }
}


export function dataURLtoFile(dataurl, filename) {
  // 获取到base64编码
  const arr = dataurl.split(',')
  // 将base64编码转为字符串
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg',
  })
}

export function fileToBase64 (file) {
  let reader = new FileReader()
  reader.readAsDataURL(file)
  return new Promise((resolve) => {
    reader.onload = function (e) {
      resolve({base64: e.target.result})
    }
  })
}
export function base64ToBlob (urlData, imageType = 'jpg') {
  const bytes = window.atob(urlData.split(',')[1])
  const ab = new ArrayBuffer(bytes.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob( [ab] , {type : `image/${imageType}`})
}

export function compressImage(fileObj) {
  // 图片小于1M不压缩
  let oSize = fileObj.size;
  if (oSize < 1048576) return fileToBase64(fileObj)
  return new Promise((resolve) => {
    let reader = new FileReader();
    // 获取文件名称，后续下载重命名
    let fileName = fileObj.name ? '' : `${new Date().getTime()}-${fileObj.name}`;
    reader.readAsDataURL(fileObj)
    reader.onload = e => {
      const path = e.currentTarget.result
      let img = new Image()
      img.src = path
      img.onload = function () {
        const originHeight = img.height
        const originWidth = img.width
        console.log('原始宽高', originHeight, originWidth)
        let compressedWidth = img.height
        let compressedHeight = img.width
        if (oSize <= 3 * 1048576) {
          compressedHeight = originHeight * 0.7
          compressedWidth = originWidth * 0.7
        } else if (oSize > 3 * 1048576 && oSize <= 5 * 1048576) {
          compressedHeight = originHeight * 0.6
          compressedWidth = originWidth * 0.6
        } else if (oSize > 5 * 1048576) {
          compressedHeight = originHeight * 0.5
          compressedWidth = originWidth * 0.5
        }
        // 生成canvas
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        canvas.height = compressedHeight
        canvas.width = compressedWidth
        console.log('压缩宽高', compressedHeight, compressedWidth)
        // context.globalAlpha = 0.2;
        context.clearRect(0, 0, compressedWidth, compressedHeight)
        context.drawImage(img, 0, 0, compressedWidth, compressedHeight)

        let base64 = canvas.toDataURL('image/*')
        // 通过base64转二进制
        // let blob = convertBase64UrlToBlob(base64);
        // 通过canvas转二进制
        canvas.toBlob((blob)=>{
          //回调函数返回blob的值。也可根据自己的需求返回base64的值
          resolve({blob,base64,fileName,oSize})
        },'image/jpeg', 1);
      }
    }
  })
}

export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}